import { InfoWindow, Marker } from "@react-google-maps/api";
import * as React from "react";
import { FindDealerMarkerCurrentPositionProps } from ".";

export default function MarkerCurrentPosition({
    location,
    currentPositionTooltipOpen,
    setCurrentPositionTooltipOpen,
    ...props
}: FindDealerMarkerCurrentPositionProps) {
    const [marker, setMarker] = React.useState(null);

    const handleLoad = React.useCallback((marker: google.maps.Marker) => {
        setMarker(marker);
    }, []);

    const handleUnmount = React.useCallback((marker: google.maps.Marker) => {
        setMarker(null);
    }, []);

    if (typeof location?.lat !== "number" || typeof location?.lng !== "number") {
        return null;
    }

    return (
        <Marker
            position={location}
            icon={{
                url:
                    props.settings?.find_dealer_marker_current_position_icon?.url ||
                    "https://resources.tmp.dk/images/icons/markers/current-position.png",
                scaledSize: new google.maps.Size(25, 40),
            }}
            onLoad={handleLoad}
            onUnmount={handleUnmount}
            onClick={() => setCurrentPositionTooltipOpen((prev) => !prev)}
        >
            {marker && currentPositionTooltipOpen && (
                <InfoWindow onCloseClick={() => setCurrentPositionTooltipOpen(false)}>
                    <div style={{ marginRight: 10 }}>
                        {props.settings?.find_dealer_you_are_here_text}
                    </div>
                </InfoWindow>
            )}
        </Marker>
    );
}
